import { Component } from '@angular/core';

@Component({
  selector: 'app-cards5-examples-30',
  templateUrl: './cards5-examples-30.component.html'
})
export class Cards5Examples30Component {}
